import * as XLSX from 'xlsx'
import {HistoryData, HistoryExtendedMetrics} from '../services/historyApi'

function operationalMetrics(item: HistoryExtendedMetrics) {
  return {
    SaidaPerdas: item.total_saida_perdas ?? null,
    DivergenciaEstoque: item.total_divergencia_estoque ?? null,
    QuantidadePedida: item.total_quantidade_pedida ?? null,
    QuantidadeEntregue: item.total_quantidade_entregue ?? null,
    OTIFPontualidadePct: item.avg_otif_pontualidade_pct ?? null,
    OTIFCompletudePct: item.avg_otif_completude_pct ?? null,
    OTIFPct: item.avg_otif_pct ?? null,
  }
}

// Explicit columns keep exports restricted to operational information,
// including when an older server response contains additional fields.
export function buildStockHistoryWorkbook(data: HistoryData): XLSX.WorkBook {
  const book = XLSX.utils.book_new()
  const summary = data.summary
  XLSX.utils.book_append_sheet(book, XLSX.utils.json_to_sheet([{
    Importacoes: summary.imports, Produtos: summary.products, CNPJs: summary.cnpjs,
    Saida: summary.total_saida, Entrada: summary.total_entrada, EstoqueMedio: summary.avg_stock,
    CoberturaMedia: summary.avg_coverage, Rupturas: summary.rupturas,
    ...operationalMetrics(summary),
  }]), 'Resumo')
  XLSX.utils.book_append_sheet(book, XLSX.utils.json_to_sheet(data.products.map(item => ({
    EAN: item.ean, Produto: item.produto, Industria: item.industria,
    Importacoes: item.imports, CNPJs: item.cnpjs,
    Saida: item.total_saida, Entrada: item.total_entrada, EstoqueMedio: item.avg_stock,
    EstoqueInicial: item.first_stock, EstoqueAtual: item.latest_stock,
    Variacao: item.stock_variation, CMD: item.avg_cmd, Cobertura: item.avg_coverage,
    Participacao: item.sales_share,
    ...operationalMetrics(item),
  }))), 'Produtos')
  XLSX.utils.book_append_sheet(book, XLSX.utils.json_to_sheet(data.series.map(item => ({
    period: item.period, total_saida: item.total_saida, total_entrada: item.total_entrada,
    avg_stock: item.avg_stock, rupturas: item.rupturas, avg_coverage: item.avg_coverage,
    ...operationalMetrics(item),
  }))), 'Evolução')
  XLSX.utils.book_append_sheet(book, XLSX.utils.json_to_sheet(data.suppliers.map(item => ({
    label: item.label, supplier_id: item.supplier_id, product_count: item.product_count,
    total_saida: item.total_saida, avg_stock: item.avg_stock, avg_coverage: item.avg_coverage,
    ...operationalMetrics(item),
  }))), 'Fornecedores')
  XLSX.utils.book_append_sheet(book, XLSX.utils.json_to_sheet(data.imports.map(item => ({
    import_id: item.import_id, status: item.status, source_files: item.source_files.join(', '),
    reference_start: item.reference_start, reference_end: item.reference_end,
    total_received: item.total_received, total_valid: item.total_valid,
    total_invalid: item.total_invalid, supplier_count: item.supplier_count,
    created_at: item.created_at, completed_at: item.completed_at,
  }))), 'Importações')
  return book
}
